import { WorkOrderPaymentMethodEnum } from "@repo/graphql/gql/graphql";

import { PaymentBreakdownGroup } from "../paymentBreakdown/types";

/** Shared between the work-order brand checkout and the affiliate payout
 * checkout — both group the same breakdown line kinds under the same
 * captions. */
export const BREAKDOWN_GROUPS: PaymentBreakdownGroup[] = [
  { label: "Creadores", kinds: ["CREATOR_NET", "RETENTION"] },
  { label: "Montu", kinds: ["SERVICE_FEE", "VAT", "PROVIDER_FEE"] },
];

/** Labels for the method selector buttons. A `Partial` record because each
 * checkout only ever offers a subset of the enum. */
export const PAYMENT_METHOD_LABELS: Partial<
  Record<WorkOrderPaymentMethodEnum, string>
> = {
  [WorkOrderPaymentMethodEnum.Wallet]: "Billetera Montu",
  [WorkOrderPaymentMethodEnum.Debit]: "Tarjeta",
  [WorkOrderPaymentMethodEnum.Credit]: "Factura",
  [WorkOrderPaymentMethodEnum.Free]: "Gratis",
};

/** Labels for the pay button itself, keyed by the method actually being
 * submitted. */
export const PAY_BUTTON_LABELS: Record<WorkOrderPaymentMethodEnum, string> = {
  [WorkOrderPaymentMethodEnum.Wallet]: "Pagar con la billetera",
  [WorkOrderPaymentMethodEnum.Debit]: "Pagar con tarjeta",
  [WorkOrderPaymentMethodEnum.Credit]: "Pagar con factura",
  [WorkOrderPaymentMethodEnum.Free]: "Pagar",
};
